import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

export const isUnlockChoiceOfferOrReservation = (entryPoint: UnlockChoiceEntryPoint | undefined): boolean =>
    entryPoint === UnlockChoiceEntryPoint.PRICE || entryPoint === UnlockChoiceEntryPoint.LEAD;
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

export const isUnlockChoiceOfferOrReservation = (entryPoint: UnlockChoiceEntryPoint | undefined): boolean =>
    entryPoint === UnlockChoiceEntryPoint.PRICE || entryPoint === UnlockChoiceEntryPoint.LEAD;
